import { useMutation } from '@tanstack/react-query';

import { Api } from '@/shared/api';
import { useCurrentProject } from '@/shared/projects/project-path';

export function useDeleteCategoryMutation() {
  const project = useCurrentProject();
  return useMutation({
    mutationFn: (id: number) => Api.categories.deleteCategory(project, id),
  });
}
